import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

import {
  ButtonIconSize, ButtonIconType
} from '@design-system/components/molecules/button-icon/entities/button-icon.types';
import { LoaderRingType } from '@design-system/components/atoms/loader-ring/entities/loader-ring.types';
import { Icon, IconFillColor } from '@design-system/components/atoms/icon/entities/icon.types';
import {
  TypographyColor, TypographyFontFamily, TypographyFontSize
} from '@design-system/components/atoms/typography/entities/typography.types';
import { LoaderRingDsComponent } from '@design-system/components/atoms/loader-ring/loader-ring.component';
import { IconDsComponent } from '@design-system/components/atoms/icon/icon.component';
import { TypographyDsComponent } from '@design-system/components/atoms/typography/typography.component';

@Component({
  selector: 'app-ds-button-icon',
  templateUrl: './button-icon.component.html',
  styleUrls: ['./button-icon.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    LoaderRingDsComponent,
    IconDsComponent,
    TypographyDsComponent,
  ]
})
export class ButtonIconDsComponent {

  @Input() icon = Icon.Close;
  @Input() type = ButtonIconType.Primary;
  @Input() buttonSize = ButtonIconSize.SM;
  @Input() iconSize = 16;
  @Input() isLoading = false;
  @Input() label: string;
  @Input() labelSize = TypographyFontSize.Minor;
  @Input() labelFontFamily = TypographyFontFamily.Regular;
  @Input() labelColor = TypographyColor.Primary;

  @Output() clickEvent: EventEmitter<void> = new EventEmitter<void>();

  public readonly loaderRingType = LoaderRingType.Neutral;

  public readonly iconColor = IconFillColor.Primary;

  constructor() { }

}
